<template>
  <div class="i-addr">
    <div class="up">
      <!-- 我的地址 -->
      <div class="facab">
        <div class="oText">{{ $t('main.addressList') }}</div>
        <div class="tEndAdd color-635796 cPointer" @click="dialogVisible = true;operateFlag=true">
          + {{ $t('main.addAddress') }}
        </div>
      </div>
    </div>
    <div class="down">
      <div v-for="(item, index) in addList" :key="index" class="context">
        <div class="facab">
          <div>
            <div>{{ $t('main.receiver') }}：{{ item.receive_user }}</div>
            <div v-if="isCN" style="margin-top: 1.25rem;">
              {{ $t('main.Address') }}：{{ item.receive_address }}
            </div>
            <div v-if="!isCN" style="margin-top: 1.25rem;">
              {{ $t('main.AddressLine1') }}：{{ item.receive_address }}
            </div>
            <div v-if="!isCN && item.receive_address_2" style="margin-top: 1.25rem;">
              {{ $t('main.AddressLine2') }}：{{ item.receive_address_2 }}
            </div>
            <div v-if="!isCN && item.receive_address_3" style="margin-top: 1.25rem;">
              {{ $t('main.AddressLine3') }}：{{ item.receive_address_3 }}
            </div>
          </div>

          <div class="fac">
            <div style="line-height: 1.25rem;" class="fac" v-if="item.status == 1">
              <img src="/static/user/icn_choosed.png" class="mImg" />
              <div style="margin-left: 0.625rem;">{{ $t('main.defaultAddress') }}</div>
            </div>
            <div class="cPointer color-635796 cPointer" @click="setDefault(item)" v-else>{{ $t('main.setDefault') }}</div>
            <div class="ml28 color-635796 cPointer" @click="editDialog(item)">{{ $t('main.edit') }}</div>
            <div class="ml28 color-635796 cPointer" @click="delAddress(item.id)">{{ $t('main.delete') }}</div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="!addList.length">{{ $t('main.noData') }}</div>
    </div>
    <div>
      <el-pagination
          layout="prev, pager, next"
          hide-on-single-page
          :total="total"
          :current-page="page"
          :page-size="limit"
          @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog :title="$t('main.ConsigneeInformation')" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-form ref="form" :model="formData" label-width="150px">
        <el-form-item class="is-required" :label="$t('main.receiver')">
          <el-input v-model="formData.receive_user" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.telephone')">
          <el-input v-model="formData.receive_phone" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.country')">
          <el-select
              v-model="formData.country"
              clearable
              style="width: 100%"
              size="small"
              :placeholder="$t('main.pleaseEnter')"
              filterable
              remote
              :remote-method="remoteMethod"
              @clear="handleEmpty"
              :loading="loading"
              @change="handleRemoteMethodChange($event)"
          >
            <el-option
                v-if="isCN"
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.country_name_cn"
                :value="item.ab"
            >
              <span> {{ item.country_name_cn }} </span>
              <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
            </el-option>
            <el-option
                v-if="!isCN"
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.country_name_en"
                :value="item.ab"
            >
              <span> {{ item.country_name_en }} </span>
              <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            v-if="!isCN && (formData.country == 'AR' || formData.country == 'BR' || formData.country == 'CA' || formData.country == 'ID' || formData.country == 'IN' || formData.country == 'IT' || formData.country == 'JP' || formData.country == 'MX' || formData.country == 'TH' || formData.country == 'US')"
            class="is-required"
            :label="stateTitle"
        >
          <el-select
              v-model="formData.state"
              clearable
              style="width: 100%"
              size="small"
              :placeholder="$t('main.pleaseEnter')"
              filterable
              remote
              :remote-method="remoteStateMethod"
              @clear="handleStateEmpty"
              :loading="loading"
              @change="handleStateRemoteMethodChange($event)"
          >
            <el-option
                v-for="(item, index) in stateList"
                :key="index"
                :label="item.state_name"
                :value="item.state_code"
            >
              <span> {{ item.state_name }} </span>
              <span style="color: #8492a6"> ({{ item.state_code }})</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.city')">
          <el-input v-model="formData.city" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item
            :class="isCN ? '': 'is-required'"
            :label="$t('main.postalCode')"
        >
          <el-input v-model="formData.postal_code" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.orderCompany')">
          <el-input v-model="formData.receive_company" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.TaxpayerIdentificationNumber')">
          <el-input
              v-model="formData.number"
              :placeholder="$t('main.pleaseEnter')"
          ></el-input>
        </el-form-item>
        <el-form-item class="is-required" v-if="isCN" :label="$t('main.addressDetail')">
          <el-input v-model="formData.receive_address" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" v-if="!isCN" :label="$t('main.AddressLine1')">
          <el-input v-model="formData.receive_address" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item v-if="!isCN" :label="$t('main.AddressLine2')">
          <el-input v-model="formData.receive_address_2" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item v-if="!isCN" :label="$t('main.AddressLine3')">
          <el-input v-model="formData.receive_address_3" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.setDefault')" style="width: 100%;text-align: left;">
          <el-checkbox :true-label="1"
          :false-label="0" v-model="formData.status" label-position="left"></el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="submitData">{{ $t('main.sure') }}</el-button>
        <el-button class="btn-close" @click="handleClose">{{ $t('main.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {addAdress, deleteAddress, editAddress, listAddress} from "@/api/index";
import countryList from "@/api/country.json"
import ARStateList from "@/api/AR.json"
import BRStateList from "@/api/BR.json"
import CAStateList from "@/api/CA.json"
import IDStateList from "@/api/ID.json"
import INStateList from "@/api/IN.json"
import ITStateList from "@/api/IT.json"
import JPStateList from "@/api/JP.json"
import MXStateList from "@/api/MX.json"
import THStateList from "@/api/TH.json"
import USStateList from "@/api/US.json"
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      isCN: true, // 判断当前是中文还是英文
      countryList: [],
      stateList: [],
      // 遮罩层
      loading: false,
      page: 1,
      limit: 5,
      total: 1,
      dialogVisible: false,
      addList: [],
      //请求参数
      operateFlag: false,
      formData: {
        receive_user: "",
        receive_email: "",
        receive_phone: "",
        receive_company: "",
        country: "",
        state: "",
        city: "",
        postal_code: "",
        number: "",
        receive_address: "",
        status: 0,//默认开票信息
      },
      stateTitle: '',
    };
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.isCN = this.$i18n.locale === "zn";
      }
      const userid = JSON.parse(Cookies.get('userinfo')).id;
      const params = {
        "req": {
          "page": this.page,
          "limit": this.limit,
          "where": [
            {
              "condition": userid,
              "filed": "user_id",
              "expression": "="
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            }
          ],
          "order": "id desc"
        }
      };

      // 带搜索的下拉框
      this.remoteMethod('')
      this.remoteStateMethod('')
      this.getData(params)
    }
  },
  created() {
    this.isCN = this.$i18n.locale === "zn";
    // TODO 实际会根据userid来，不是根据id
    const userid = JSON.parse(Cookies.get('userinfo')).id;
    const params = {
      "req": {
        "page": this.page,
        "limit": this.limit,
        "where": [
          {
            "condition": userid,
            "filed": "user_id",
            "expression": "="
          },
          {
            condition: Cookies.get("siteInfo"),
            filed: "site_id",
            expression: "="
          }
        ],
        "order": "id desc"
      }
    };

    // 带搜索的下拉框
    this.remoteMethod('')
    this.remoteStateMethod('')
    this.getData(params)
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;

      const userid = JSON.parse(Cookies.get('userinfo')).id;
      const params = {
        "req": {
          "page": this.page,
          "limit": this.limit,
          "where": [
            {
              "condition": userid,
              "filed": "user_id",
              "expression": "="
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            }
          ],
          "order": "id desc"
        }
      };
      this.getData(params);
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    // 带搜索的下拉框
    remoteMethod(query) {
      const country = [];
      Object.assign(country, countryList);
      if (query) {
        this.loading = true
        this.countryList = country.filter(
            item => item.country_name_cn.toLowerCase().includes(query.toLowerCase()) ||
                item.country_name_en.toLowerCase().includes(query.toLowerCase()) ||
                item.ab.toLowerCase().includes(query.toLowerCase()) ||
                item.country_code == query
        )
        this.loading = false
      } else {
        this.countryList = country;
      }
    },
    handleEmpty() {
      const country = [];
      Object.assign(country, countryList);
      this.countryList = country;
    },
    handleRemoteMethodChange (e) {
      this.formData.country = e;
      const country = [];
      Object.assign(country, countryList);
      this.countryList = country;

      const state = [];
      if (this.formData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.formData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.formData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.formData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.formData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.formData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.formData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.formData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },
    remoteStateMethod (query) {
      if (query) {
        this.loading = true
        const state = [];
        if (this.formData.country == 'AR') {
          this.stateTitle = "Province name";
          Object.assign(state, ARStateList);
        } else if (this.formData.country == 'CA') {
          this.stateTitle = "Province name";
          Object.assign(state, CAStateList);
        } else if (this.formData.country == 'ID') {
          this.stateTitle = "Province name";
          Object.assign(state, IDStateList);
        } else if (this.formData.country == 'IT') {
          this.stateTitle = "Province name";
          Object.assign(state, ITStateList);
        } else if (this.formData.country == 'TH') {
          this.stateTitle = "Province name";
          Object.assign(state, THStateList);
        } else if (this.formData.country == 'BR') {
          this.stateTitle = "State name";
          Object.assign(state, BRStateList);
        } else if (this.formData.country == 'IN') {
          this.stateTitle = "State name";
          Object.assign(state, INStateList);
        } else if (this.formData.country == 'MX') {
          this.stateTitle = "State name";
          Object.assign(state, MXStateList);
        } else if (this.formData.country == 'US') {
          this.stateTitle = "State name";
          Object.assign(state, USStateList);
        } else if (this.formData.country == 'JP') {
          this.stateTitle = "Prefecture name";
          Object.assign(state, JPStateList);
        }
        this.stateList = state.filter(
            item => item.state_name.toLowerCase().includes(query.toLowerCase()) ||
                item.state_code.toLowerCase().includes(query.toLowerCase())
        )
        this.loading = false
      } else {
        const state = [];
        if (this.formData.country == 'AR') {
          this.stateTitle = "Province name";
          Object.assign(state, ARStateList);
          this.stateList = state;
        } else if (this.formData.country == 'CA') {
          this.stateTitle = "Province name";
          Object.assign(state, CAStateList);
          this.stateList = state;
        } else if (this.formData.country == 'ID') {
          this.stateTitle = "Province name";
          Object.assign(state, IDStateList);
          this.stateList = state;
        } else if (this.formData.country == 'IT') {
          this.stateTitle = "Province name";
          Object.assign(state, ITStateList);
          this.stateList = state;
        } else if (this.formData.country == 'TH') {
          this.stateTitle = "Province name";
          Object.assign(state, THStateList);
          this.stateList = state;
        } else if (this.formData.country == 'BR') {
          this.stateTitle = "State name";
          Object.assign(state, BRStateList);
          this.stateList = state;
        } else if (this.formData.country == 'IN') {
          this.stateTitle = "State name";
          Object.assign(state, INStateList);
          this.stateList = state;
        } else if (this.formData.country == 'MX') {
          this.stateTitle = "State name";
          Object.assign(state, MXStateList);
          this.stateList = state;
        } else if (this.formData.country == 'US') {
          this.stateTitle = "State name";
          Object.assign(state, USStateList);
          this.stateList = state;
        } else if (this.formData.country == 'JP') {
          this.stateTitle = "Prefecture name";
          Object.assign(state, JPStateList);
          this.stateList = state;
        }
      }
    },
    handleStateEmpty() {
      const state = [];
      if (this.formData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.formData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.formData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.formData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.formData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.formData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.formData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.formData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },
    handleStateRemoteMethodChange(e) {
      const state = [];
      if (this.formData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.formData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.formData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.formData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.formData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.formData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.formData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.formData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },
    // 清空表单
    resetForm(){
      this.formData = {
        receive_user: "",
        receive_email: "",
        receive_phone: "",
        receive_company: "",
        country: "",
        state: "",
        city: "",
        postal_code: "",
        number: "",
        receive_address: "",
        receive_address_2: "",
        receive_address_3: "",
        status: 0,//默认开票信息
      }
    },
    getData(params) {
      listAddress(params).then((res) => {
        this.addList = res.data.list;
        this.total = res.data.total;
      });

      // TODO 默认地址特殊处理
    },
    setDefault(params) {
      var setparams = params;
      setparams.status = 1;
      var setparamstrue = {
        "req": {
          "id": params.id,
          "info": setparams
        }
      }
      editAddress(setparamstrue).then((res) => {
        if (res.rsp.code === 0) {
          var userid = JSON.parse(Cookies.get('userinfo')).id;
          var params = {
            "req": {
              "page": this.page,
              "limit": this.limit,
              "where": [
                {
                  "condition": userid,
                  "filed": "user_id",
                  "expression": "="
                },
                {
                  condition: Cookies.get("siteInfo"),
                  filed: "site_id",
                  expression: "="
                }
              ],
              "order": "id desc"
            }
          };
          this.getData(params);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success',
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    delAddress(id) {
      var delPa= {
        "req": {
          "ids": id
        }
      }
      this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
        confirmButtonText: this.$t('main.sure'),
        cancelButtonText: this.$t('main.cancel'),
        type: 'warning',
      })
        .then(() => {
          deleteAddress(delPa).then((res) => {
            if (res.rsp.code === 0) {
              var userid = JSON.parse(Cookies.get('userinfo')).id;
              var params = {
                "req": {
                  "page": this.page,
                  "limit": this.limit,
                  "where": [
                    {
                      "condition": userid,
                      "filed": "user_id",
                      "expression": "="
                    },
                    {
                      condition: Cookies.get("siteInfo"),
                      filed: "site_id",
                      expression: "="
                    }
                  ],
                  "order": "id desc"
                }
              }
              this.$message({
                message: this.$t('main.operationCompletedSuccessfully'),
                type: 'success',
              });
              this.getData(params);
            } else {
              this.$message({
                message: res.rsp.msg,
                type: 'error'
              })
            }
          })
        })
          .catch(() => {
            // 点击取消按钮后的回调函数
            // 可以不做任何操作
          })
    },
    editDialog(item) {
      this.dialogVisible = true;
      this.operateFlag = false;
      this.formData = item;

      const state = [];
      if (this.formData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.formData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.formData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.formData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.formData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.formData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.formData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.formData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.formData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },

    //添加和修改
    submitData() {
      // TODO 组装数据
      var userid = JSON.parse(Cookies.get('userinfo')).id;
      var listParams = {
        "req": {
          "page": this.page,
          "limit": this.limit,
          "where": [
            {
              "condition": userid,
              "filed": "user_id",
              "expression": "="
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            }
          ],
          "order": "id desc"
        }
      };

      if (this.operateFlag == false) {
        var params = {
          "req": {
            "id": this.formData.id,
            "info": this.formData
          }
        }
        if (this.isCN && !this.formData.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN && !this.formData.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN &&
            (this.formData.country == 'AR' || this.formData.country == 'BR' || this.formData.country == 'CA' || this.formData.country == 'ID' || this.formData.country == 'IN' || this.formData.country == 'IT' || this.formData.country == 'JP' || this.formData.country == 'MX' || this.formData.country == 'TH' || this.formData.country == 'US') &&
            !this.formData.state
        ) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.stateTitle }),
            type: 'error'
          })
          return
        }
        editAddress(params).then((res) => {
          if(res.rsp.code === 0) {
            this.getData(listParams);
            this.handleClose();
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success',
            })
          }else{
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      } else {
        var params2 = {
          "req": {
            "user_id": JSON.parse(Cookies.get('userinfo')).id,
            "receive_user": this.formData.receive_user,
            "receive_email": this.formData.receive_email,
            "receive_phone": this.formData.receive_phone,
            "receive_company": this.formData.receive_company,
            "country": this.formData.country,
            "state":this.formData.state,
            "city": this.formData.city,
            "postal_code": this.formData.postal_code,
            "number": this.formData.number,
            "receive_address": this.formData.receive_address,
            "receive_address_2": this.formData.receive_address_2,
            "receive_address_3": this.formData.receive_address_3,
            "status": 0
          }
        }
        if (this.isCN && !this.formData.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN && !this.formData.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN &&
            (this.formData.country == 'AR' || this.formData.country == 'BR' || this.formData.country == 'CA' || this.formData.country == 'ID' || this.formData.country == 'IN' || this.formData.country == 'IT' || this.formData.country == 'JP' || this.formData.country == 'MX' || this.formData.country == 'TH' || this.formData.country == 'US') &&
            !this.formData.state
        ) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.stateTitle }),
            type: 'error'
          })
          return
        }
        addAdress(params2).then((res) => {
          if(res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success',
            })
            this.getData(listParams);
            this.handleClose();
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.i-addr {
  min-height: 46.25rem;
  background: #fafafa;
  border: 1px solid #e5e5e5;

  .up {
    width: 100%;
    height: 4.375rem;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e5e5;
    line-height: 4.375rem;

    .oText {
      color: #1a1a1a;
      margin-left: 1.5rem;
      cursor: pointer;
    }

    .tEndAdd {
      padding-right: 2.5rem;
    }
  }

  .down {
    max-height: calc(46.25rem - 12.375rem);
    overflow-y: auto;

    .no-data {
      width: 100%;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }
    .context {
      margin-top: 1.875rem;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
      padding: 2.25rem 2.5rem;

      .mImg {
        width: 1.5rem;
      }

      .ml28 {
        margin-left: 1.75rem;
      }
    }
  }

  /deep/ .el-pager li {
    background: #fff;
    margin: 0.1rem;
  }
  /deep/ .el-pagination {
    text-align: center;
  }
  /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
    color: #635796;
  }
  /deep/ .el-pager li.active {
    background: #635796;
    color: #fff!important;
  }
  /deep/ .el-pager li:hover {
    background: #635796;
    color: #fff!important;
  }

  /deep/ .el-input__suffix {
    height: 32px;
  }

  /deep/ .el-input__suffix .el-input__icon{
    color: #c0c4cc;
    line-height: 32px;
  }

  .color-635796 {
    color: #635796;
  }

  /deep/ .el-dialog__header {
    background: #f2f2f2;
    padding: 1rem 1rem 1rem 1.5rem;
    border-radius: 2px;
  }

  /deep/ .el-dialog__title {
    color: #000000;
  }

  /deep/ .el-dialog__body {
    padding: 2.5rem 3rem;
  }

  /deep/ .el-dialog__footer {
    text-align: center;
  }
  .btn {
    background: #635796;
    border-radius: 4px;
    border-color: #635796;
    color: #ffffff;
  }
  .btn-close {
    background: #FFF;
    border-radius: 4px;
    border-color: #DCDFE6;
    color: #606266;
  }
}
</style>
